module.exports = __webpack_public_path__ + "img/user-7.963bb38d.jpg";